import { blinkConstants } from '@thoughtspot/blink-constants';
import { translate as t } from '@thoughtspot/i18n';
import { jsonConstants } from '@thoughtspot/json-constants';
import { assign } from '@thoughtspot/string-util';
import _ from 'lodash';
export var ConnectionTypeEnum;
(function (ConnectionTypeEnum) {
    ConnectionTypeEnum["LOGICAL_TABLE"] = "LOGICAL_TABLE";
    ConnectionTypeEnum["DATA_SOURCE"] = "DATA_SOURCE";
})(ConnectionTypeEnum || (ConnectionTypeEnum = {}));
export const GETTING_STARTED_URLS = {
    DEVELOPER_EDITION: 'https://developers.thoughtspot.com/docs/getting-started',
    FREE_TRIAL: 'https://docs.thoughtspot.com/cloud/latest/getting-started-free-trial',
};
const metadataType = jsonConstants.metadataType;
var Connections;
(function (Connections) {
    Connections["URL_PREFIX"] = "#/{1}/{2}";
    Connections["SQL_VIEW_URL_PREFIX"] = "#/data/{1}/{2}/";
    Connections["NO_CONNECTION"] = "metadataListPage.dataManagement.embrace.noConnection";
    Connections["NO_CONNECTION_DESC"] = "metadataListPage.dataManagement.embrace.noConnectionDesc";
    Connections["OTHERS"] = "cirrus.page.connections.others";
    Connections["CONNECTION_EDIT"] = "datamodel.connection.edit";
    Connections["CONNECTION_TITLE"] = "cirrus.page.connections.title";
    Connections["CONNECTION_DESC"] = "cirrus.page.connections.create.description";
    Connections["SAVE_DESC"] = "saveDialog.Description";
    Connections["SAVE_NAME"] = "saveDialog.Name";
    Connections["UPDATE_CONN_NAME"] = "cirrus.connection.name.update.message";
    Connections["SEARCH"] = "SEARCH";
    Connections["CONNECTION_TABLE"] = "cirrus.card.connectionDetail.tables";
    Connections["CONNECTION_CREATEDBY"] = "cirrus.card.connectionDetail.createdBy";
    Connections["CONNECTION_MODIFIEDBY"] = "cirrus.card.connectionDetail.modifiedBy";
    Connections["DELETEMODAL_MSG"] = "cirrus.connection.deletemodal.message";
    Connections["DEPENDENT_CANNOTDELETE"] = "alert.dataDeletionAlertMessages.cannotDelete";
    Connections["DEPENDENT_SINGULAR"] = "alert.dataDeletionAlertMessages.withDependents.singular";
    Connections["DEPENDENT_PLURAL"] = "alert.dataDeletionAlertMessages.withDependents.plural";
    Connections["MORE"] = "MORE";
    Connections["CONNECTION"] = "cirrus.sqlView.header.connection.title";
})(Connections || (Connections = {}));
const displayName = {
    Answer: () => t('ANSWER'),
    Column: () => t('COLUMN'),
    Connection: () => t('embrace.CONNECTION'),
    Data_Source: () => t('tooltip.SOURCE'),
    Filter: () => t('tokenType.FILTER'),
    Import_Table: () => t('metadataExplorer.types.USER_DEFINED'),
    Insight: () => t('DataExplorerVisibleDependents.INSIGHT_ANSWER_BOOK'),
    Object: () => t('OBJECT'),
    Pinboard: () => t('PINBOARD'),
    Relationship: () => t('Relationship'),
    Rule: () => t('Rule'),
    System_Table: () => t('metadataExplorer.types.ONE_TO_ONE_LOGICAL'),
    Table: () => t('DataExplorerVisibleDependents.LOGICAL_TABLE.ONE_TO_ONE_LOGICAL'),
    View: () => t('pinboardExport.sectionHeading.view'),
    Visualization: () => t('embed.embeddedObjectType.VISUALIZATION'),
    Worksheet: () => t('DocumentType.WORKSHEET'),
    Model: () => t('DocumentType.MODEL'),
    SQL_VIEW: () => t('SQL_VIEW'),
    Group: () => t('Group'),
    Lesson_plan: () => t('LESSON_PLAN'),
};
export const getUrlPrefixForMetadataType = (type, subType, isAutoCreated) => {
    switch (type) {
        case metadataType.QUESTION_ANSWER_BOOK:
            return blinkConstants.SAVED_ANSWER_TYPE;
        case metadataType.PINBOARD_ANSWER_BOOK:
            if (isAutoCreated) {
                return 'insight';
            }
            return blinkConstants.PINBOARD_TYPE;
        case metadataType.LOGICAL_TABLE:
            switch (subType) {
                case metadataType.subType.WORKSHEET:
                    return blinkConstants.WORKSHEET_TYPE;
                case metadataType.subType.VIEW:
                    return blinkConstants.LESSON_PLAN_URL_PREFIX;
                case metadataType.subType.SQL_VIEW:
                    return blinkConstants.SQLVIEW;
                case metadataType.subType.LESSON_PLAN:
                case metadataType.subType.ONE_TO_ONE_LOGICAL:
                case metadataType.subType.USER_DEFINED:
                    return blinkConstants.DATA_TABLES_URL_PREFIX;
                default:
                    return undefined;
            }
        case metadataType.DESTINATION:
            return 'destination-sync';
        default:
            return undefined;
    }
};
export const getDisplayNameForMetadataType = (pageType, subType = null, isAutoCreated = null, worksheetVersion = 'V1') => {
    switch (pageType) {
        case metadataType.QUESTION_ANSWER_BOOK:
            return displayName.Answer();
        case metadataType.PINBOARD_ANSWER_BOOK:
            if (isAutoCreated) {
                return displayName.Insight();
            }
            return displayName.Pinboard();
        case metadataType.LOGICAL_TABLE:
            switch (subType) {
                case metadataType.subType.SYSTEM_TABLE:
                    return displayName.System_Table();
                case metadataType.subType.IMPORTED_DATA:
                    return displayName.Import_Table();
                case metadataType.subType.WORKSHEET:
                    if (worksheetVersion === 'V2') {
                        return displayName.Model();
                    }
                    return displayName.Worksheet();
                case metadataType.subType.VIEW:
                    return displayName.View();
                case metadataType.subType.SQL_VIEW:
                    return displayName.SQL_VIEW();
                case metadataType.subType.LESSON_PLAN:
                case metadataType.subType.ONE_TO_ONE_LOGICAL:
                    return displayName.Lesson_plan();
                default:
                    return displayName.Table();
            }
        case metadataType.LOGICAL_COLUMN:
            return displayName.Column();
        case metadataType.LOGICAL_RELATIONSHIP:
            return displayName.Relationship();
        case metadataType.VISUALIZATION:
            return displayName.Visualization();
        case metadataType.TABLE_FILTER:
            return displayName.Rule();
        case metadataType.DATA_SOURCE:
            return displayName.Data_Source();
        case metadataType.CONNECTION:
            return displayName.Connection();
        case metadataType.FILTER:
            return displayName.Filter();
        case metadataType.GROUP:
            return displayName.Group();
        default:
            return displayName.Object();
    }
};
export const getName = (item) => {
    const dependentName = getDisplayNameForMetadataType(item.type, item.subType, item.isAutoCreated, item.worksheetVersion);
    return dependentName;
};
export const getURL = (item) => {
    const urlPrefix = getUrlPrefixForMetadataType(item.type, item.subType, item.isAutoCreated);
    if (urlPrefix) {
        if (item.subType === jsonConstants.metadataType.subType.SQL_VIEW) {
            return assign(Connections.SQL_VIEW_URL_PREFIX, urlPrefix, item.id);
        }
        return assign(Connections.URL_PREFIX, urlPrefix, item.id);
    }
    return '';
};
export const getParsedDependents = (dependentsData, filterBy) => {
    const dependents = [];
    if (!dependentsData)
        return null;
    _.forEach(_.keys(dependentsData?.Dependency__listDependents), (key) => {
        if (filterBy && key !== filterBy)
            return null;
        dependentsData?.Dependency__listDependents[key].forEach((dependentObject) => {
            dependents.push({
                name: dependentObject.name,
                type: key,
                subType: dependentObject.type,
                id: dependentObject.id,
                worksheetVersion: dependentObject.worksheetVersion,
            });
        });
        return null;
    });
    if (_.isEmpty(dependents)) {
        return null;
    }
    return dependents;
};
//# sourceMappingURL=dependents.js.map